import { useTranslation } from 'react-i18next'
import { Box, alpha } from '@mui/material'
import CustomTabs from '@/views/components/custom-tabs/custom-tabs.component'

import { PersonalizationEngineComponent } from '@/views/personalization-engine'
import { colors } from '@/theme/colors.theme'
import { OverviewComponent } from './overview.component'

import { useHome } from '../hooks'

export const MainTabComponent = () => {
  const { t } = useTranslation()

  const { currentTab } = useHome()

  return (
    <Box>
      <CustomTabs
        tabsArray={[
          {
            id: 0,
            title: t('labels.overview'),
            label: 'overview',
            childrenComponent: <OverviewComponent />,
          },
          {
            id: 1,
            title: t('labels.personalizationEngine'),
            label: 'personalization',
            childrenComponent: <PersonalizationEngineComponent />,
          },
        ]}
        activeTab={currentTab === 'overview' ? 0 : 1}
        sxPanel={{
          backgroundColor: 'transparent',
          pt: '10px',
          borderTop: `2px solid ${alpha(colors.black, 0.1)}`,
        }}
        sxTab={{
          '& .MuiTab-root': {
            paddingBottom: '15px',
          },
        }}
      />
    </Box>
  )
}
